// @ts-check
const INVALID_DATE = 'Invalid Date';

/**
 * @param {string} rawDate
 */
function formatDate(rawDate) {
  if (!rawDate) return '';

  const date = new Date(Date.parse(rawDate));
  if (String(date) === INVALID_DATE) return '';

  const day = date.getDate().toString().padStart(2, '0');
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${String(month).padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
}

/**
 * @param {string | boolean} rawBool
 */
function formatBool(rawBool) {
  return ['yes', 'Yes', true].includes(rawBool) ? 'Yes' : 'No';
}

/**
 *
 * @param {string} email
 * @returns {string} The portion of the email before the @ symbol, typically an Asurite ID.
 */
function formatUsername(email) {
  return email.split('@')[0];
}

export { formatDate, formatBool, formatUsername };
